import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import truckPng   from 'src/assets/semi.png';
import installSvg from 'src/assets/2jKMY8AFOqiToSHy1XkhiN26QCc.svg';

const containerStyle = { width: '100%', height: '600px' };

const MapBoxTrackDriver = ({ trucks = [], installs = [], routeGeo = null }) => {
  const mapRef   = useRef(null);
  const nodeRef  = useRef(null);
  const truckRef = useRef([]);   // marker refs
  const instRef  = useRef([]);

  const [styleReady, setReady] = useState(false);

  

  /* 1️⃣ init map */
  useEffect(() => {
    if (mapRef.current || !nodeRef.current) return;
    const map = new mapboxgl.Map({
      container: nodeRef.current,
      style    : 'mapbox://styles/mapbox/streets-v11',
      center   : [-118.2437, 34.0522],
      zoom     : 4,
    });
    map.addControl(new mapboxgl.NavigationControl(), 'top-right');
    map.addControl(new mapboxgl.FullscreenControl(), 'top-right');
    
    map.on('load', () => setReady(true));
    mapRef.current = map;
    return () => map.remove();
  }, []);

  /* 2️⃣ draw route line */
  useEffect(() => {
    if (!styleReady || !mapRef.current) return;
    const map = mapRef.current;

    ['route-line'].forEach(id => {
      if (map.getLayer(id))  map.removeLayer(id);
      if (map.getSource(id)) map.removeSource(id);
    });

    if (!routeGeo) return;

    map.addSource('route-line', {
      type: 'geojson',
      data: { type: 'Feature', geometry: routeGeo },
    });
    map.addLayer({
      id: 'route-line',
      type: 'line',
      source: 'route-line',
      layout: { 'line-join': 'round', 'line-cap': 'round' },
      paint: { 'line-color': '#1ccaff', 'line-width': 4 },
    });

    const bounds = routeGeo.coordinates.reduce(
      (b, [lng, lat]) => b.extend([lng, lat]),
      new mapboxgl.LngLatBounds(routeGeo.coordinates[0], routeGeo.coordinates[0])
    );
    map.fitBounds(bounds, { padding: 60 });
  }, [routeGeo, styleReady]);

  /* 3️⃣ draw truck + install markers */
  useEffect(() => {
    if (!styleReady || !mapRef.current) return;
    const map = mapRef.current;

    // clear old
    truckRef.current.forEach(m => m.remove());
    instRef .current.forEach(m => m.remove());
    truckRef.current = [];
    instRef.current  = [];

    /* trucks */
    truckRef.current = trucks.map(t => {
      const el = document.createElement('img');
      el.src   = truckPng;
      el.style.width = '24px'; el.style.height = '24px';
      return new mapboxgl.Marker(el)
        .setLngLat([t.lng, t.lat])
        .setPopup(new mapboxgl.Popup({ offset: 25 })
          .setHTML(`<strong>${t.driver_name}</strong><br/>${Math.round(t.speed)} km/h`))
        .addTo(map);
    });

    /* installations */
    instRef.current = installs.map(p => {
      const el = document.createElement('img');
      el.src   = installSvg;
      el.style.width = '32px'; el.style.height = '32px';
      return new mapboxgl.Marker(el)
        .setLngLat([p.lng, p.lat])
        .addTo(map);
    });
  }, [trucks, installs, styleReady]);

  return <div style={containerStyle}><div ref={nodeRef} style={containerStyle} /></div>;
};

export default MapBoxTrackDriver;
